import * as React from 'react';
import { Button } from '@repo/ui-web';
import { useCssTokens } from '../../hooks/useCssTokens';

const motionRows = [
  {
    label: 'Fast',
    duration: 'duration-fast',
    easing: 'ease-standard',
  },
  {
    label: 'Base',
    duration: 'duration-base',
    easing: 'ease-standard',
  },
  {
    label: 'Slow',
    duration: 'duration-slow',
    easing: 'ease-emphasized',
  },
];

const motionTokens = [...motionRows.flatMap((row) => [row.duration, row.easing]), 'ease-linear'];

export function MotionShowcase() {
  const values = useCssTokens(motionTokens);
  const [active, setActive] = React.useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold text-foreground">Motion tokens</p>
          <p className="text-sm text-muted-foreground">
            Durations and easing curves for interactive feedback.
          </p>
        </div>
        <Button size="md" variant="outline" onClick={() => setActive((prev) => !prev)}>
          {active ? 'Reset' : 'Play'}
        </Button>
      </div>

      <div className="space-y-4">
        {motionRows.map((row) => (
          <div key={row.label} className="rounded-2xl border border-border/40 p-4">
            <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-muted-foreground">
              <span>{row.label}</span>
              <span>
                {row.duration}: {values[row.duration]} | {row.easing}: {values[row.easing]}
              </span>
            </div>
            <div className="relative mt-4 h-10 rounded-full bg-muted/60">
              <div
                className="absolute top-2 left-2 h-6 w-6 rounded-full bg-primary"
                style={{
                  left: active ? 'calc(100% - 2rem - 8px)' : '8px',
                  transitionProperty: 'left',
                  transitionDuration: `var(--${row.duration})`,
                  transitionTimingFunction: `var(--${row.easing})`,
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-border/40 p-4 text-xs text-muted-foreground">
        <p>Linear easing: {values['ease-linear']}</p>
      </div>
    </div>
  );
}
